'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PresetOrOtherAmountComponent = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PresetAmountSelectors = require('../PresetAmountSelectors');

var _PresetAmountSelectors2 = _interopRequireDefault(_PresetAmountSelectors);

var _OtherAmount = require('../OtherAmount');

var _OtherAmount2 = _interopRequireDefault(_OtherAmount);

var _constants = require('../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PresetOrOtherAmountComponent = exports.PresetOrOtherAmountComponent = function PresetOrOtherAmountComponent(_ref) {
  var showAmountButtons = _ref.showAmountButtons,
      maxDeposit = _ref.maxDeposit,
      t = _ref.t;

  return _react2.default.createElement(
    'div',
    { className: 'qd-other-amount-form ' },
    _react2.default.createElement(
      'div',
      { className: 'label' },
      t(_constants.TRANSLATION_CONTEXT)('FORM_LBL_QUICK_DEPOSIT_AMT')
    ),
    showAmountButtons && _react2.default.createElement(_PresetAmountSelectors2.default, { formElementIndex: '4', maxDeposit: maxDeposit }),
    _react2.default.createElement(_OtherAmount2.default, { formElementIndex: '1' })
  );
};